import { MarketView } from "@/components/market/market-view"

export default function BuyerMarketPage() {
  return <MarketView />
}
